export default __webpack_public_path__ + "static/media/2020.f9c158bf.png";